import script from "./FtrHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FtrHeader.vue?vue&type=script&setup=true&lang=js"

import "./FtrHeader.vue?vue&type=style&index=0&id=b05f7fc6&lang=css"
import "./FtrHeader.vue?vue&type=style&index=1&id=b05f7fc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b05f7fc6"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QBtn,QBanner});
